import API from "../axios";

const createTelegram = async (accessToken, telegramData) => {
    try {
        const response = await API.post('/telegram/create', telegramData, {
            headers: {
                Authorization: `Bearer ${accessToken.replace('Bearer ', '')}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
        return {
            success: false,
            message: 'Lỗi kết nối mạng'
        }
    }
}

export default createTelegram; 
